export default {
  'user.Home': 'Home',
  'user.Me': 'Me',
  'user.Name': 'Name',
  'user.Message': 'Message',
  'user.View all message': 'View all message',
  'user.Learning Resource': 'Learning Resource',
  'user.Toolkit For Employee': 'Toolkit For Employee',
  'user.Privacy Notice': 'Privacy Notice',
  'user.Log out': 'Log out',
  'user.Young Talent Career Guide and Learning Resources':
    'Young Talent Career Guide and Learning Resources',
  'user.My Application': 'My Application',
  'user.Apply For ROAR Moment': 'Apply For ROAR Moment',
  'user.Your are not in the eligible scope of this round.':
    'You are not in the eligible scope of this round.',
  'user.Welcome to Project ROAR': 'Welcome to Project ROAR',
  'user.Publicis Commitment': 'Publicis Groupe China is committed to supporting our passionate and value-creating young talents from the early stage of career. With this commitment, Project ROAR is right here to provide you with the opportunity to present yourself and speed up your career progression.',
  'user.Platform Description': "In this platform, you can find the job qualifications of different roles and the learning courses required in the company. Now, it's your turn to take ownership of your own growth!",
  'user.Offline Mode Is On': 'Offline mode is on',
  'user.Latest Update': 'Latest Update',
  'user.The Project ROAR open window is closed.':
    'The Project ROAR open window is closed.',
  'user.Back': 'Back',
  'user.Notification': 'Notification',
  'user.Messages': 'Messages',
  'user.Delete All': 'Delete All',
  'user.Are you sure delete all selected messages?':
    'Are you sure delete all selected messages?',
  'user.Cancel': 'Cancel',
  'user.OK': 'OK',
  'user.Date': 'Date',
  'user.Action': 'Action',
  'user.Young Talent Career Guide and Learning Resource':
    'Young Talent Career Guide and Learning Resource',
  'user.Role:': 'Role:',
  'user.Role': 'Role',
  'user.Brand': 'Brand',
  'user.Level': 'Level',
  'user.The highlighted items show the key difference between this level and one level down.':
    'The highlighted items show the key difference between this level and one level down.',
  'user.Job Qualifications': 'Job Qualifications',
  'user.Please select role to see job qualification list.':
    'Please select role to see job qualification list.',
  'user.Learning Resources': 'Learning Resources',
  'user.You can click on the link to enroll directly. For course without link, please contact your HRBP for nomination.':
    'You can click on the link to enroll directly. ',
  'user.If you have any questions about learning, please contact':
    'If you have any questions about learning, please contact',
  'user.Please select role to see learning resources.':
    'Please select role to see learning resources.',
  'user.Title': 'Title',
  'user.Review Manager': 'Review Manager',
  'user.Delete': 'Delete',
  'user.Are you sure delete this message?': 'Are you sure delete this message?',
  'user.Application Season': 'Application Season',
  'user.Current Role': 'Current Role',
  'user.Target Role': 'Target Role',
  'user.Learning': 'Learning',
  'user.Mandatory': 'Mandatory',
  'user.Employee': 'Employee',
  'user.No Comments': 'No Comments',
  'user.View Comments': 'View Comments',
  'user.Current Role Job Qualifications': 'Current Role Job Qualifications',
  'user.Qualified': 'Qualified',
  'user.Comments': 'Comments',
  'user.Check the status of your application': 'Check the status of your application.',
  'user.Application Due Date': 'Application Due Date',
  'user.Application Date': 'Application Date',
  'user.Details': 'Details',
  'user.Panel Result': 'Panel Result',
  'user.View': 'View',
  'user.Pending': 'Pending',
  'user.Approve for Panel': 'Approve for Panel',
  'user.Disapprove for Panel': 'Disapprove for Panel',
  'user.Reopen': 'Reopen',
  'user.Your applicatinon is waiting for your review manager’s approval.':
    'Your application is waiting for your review manager’s approval.',
  'user.Your panel review applicatinon has been appproved.':
    'Your panel review application has been approved.',
  "user.Your panel review application is not approved. Please click details to view your leader's assessment and comments":
    "Your panel review application is not approved. Please click details to view your leader's assessment and comments",
  'user.Your application is reopened. Please reapply.':
    'Your application is reopened. Please reapply.',
  'user.No Application': 'No Application',
  'user.Promotion': 'Promotion',
  'user.Salary Adjustment': 'Salary Adjustment',
  'user.Transfer': 'Transfer',
  'user.Try Again Next Time': 'Try Again Next Time',
  'user.No show': 'No show',
  'user.No Participation': 'No Participation',
  'user.No Participation_Not Win': 'No Participation/Not Win',
  'user.Resigned': 'Resigned',
  'user.My Team': 'My Team',
  'user.Application Start Date': 'Application Start Date',
  'user.Application Approval Period': 'Application Approval Period',
  'user.Toolkit For Review Manager': 'Toolkit For Review Manager',
  'user.Select your current role': 'Select your current role',
  'user.Check job qualifications and leave comments':
    'Check job qualifications and leave comments',
  'user.Proceed to next step': 'Proceed to next step',
  'user.Please select your current role to see job qualification list.':
    'Please select your current role to see job qualification list.',
  'user.Theme': 'Theme',
  'user.Next': 'Next',
  'user.Check the box if you meet the qualification.':
    'Check the box if you meet the qualification.',
  'user.√ and × are marked based on the valid record of your training completion. If the mandatory courses and tests are not all completed (marked as ×), you would not be able to submit the application. If you have any question, please contact':
    '√ and × are marked based on the valid record of your training completion. If the mandatory courses and tests are not all completed (marked as ×), you would not be able to submit the application. If you have any question, please contact',
  'user.Please leave comments on the qualification boxes which are not checked.':
    'Please leave comments on the qualification boxes which are not checked.',
  'user.Optional': 'Optional',
  'user.Learning Record': 'Learning Record',
  'user.Leave Comments': 'Leave Comments',
  'user.your previous choice will be override, are you sure?':
    'your previous choice will be override, are you sure?',
  'user.Please write your comments': 'Please write your comments',
  'user.Done': 'Done',
  'user.Important Date': 'Important Date',
  'user.Group List': 'Group List',
  'user.ROAR Application HRBP Review Due Date':
    'ROAR Application HRBP Review Due Date',
  'user.Panel Result Submission Due Date': 'Panel Result Submission Due Date',
  'user.Please review the status of application, remind leaders for pending cases and reopen assessment if needed before the due date. System will automatically publish application status to the employee after this due date.':
    'Please review the status of application, remind leaders for pending cases and reopen assessment if needed before the due date. System will automatically publish application status to the employee after this due date.',
  'user.After getting global confirmation, please upload the panel result and comments before the due date. TMOD will publish the result to all before payroll cut-off date.':
    'After getting global confirmation, please upload the panel result and comments before the due date. TMOD will publish the result to all before payroll cut-off date.',
  'user.Toolkit For HRBP': 'Toolkit For HRBP',
  'user.Review the application status': 'Review the application status',
  'user.View the details if needed': 'View the details if needed',
  'user.If the application does not meet the requirements, please reopen':
    'If the application does not meet the requirements, please reopen',
  'user.Ensure that all status have been reviewed by the review manager':
    'Ensure that all status have been reviewed by the review manager',
  'user.View Group List': 'View Group List',
  'user.Export to Excel': 'Export to Excel',
  'user.Upload': 'Upload',
  'user.Number of Total Talents': 'Number of Total Talents',
  'user.Number of Applicants': 'Number of Applicants',
  'user.Employee / Review Manager': 'Employee / Review Manager',
  'user.Download assessment': 'Download assessment',
  'user.Reopen Review Manager': 'Reopen Review Manager',
  'user.Reopen Both': 'Reopen Both',
  "user.The application is waiting for review manager's approval.":
    "The application is waiting for review manager's approval.",
  'user.The panel review application has been approved.':
    'The panel review application has been approved.',
  'user.The panel review application is not approved.':
    'The panel review application is not approved.',
  "user.The talent's application is reopened.":
    "The talent's application is reopened.",
  'user.Status': 'Status',
  'user.Current Brand': 'Current Brand',
  'user.Download employee application records':
    'Download employee application records',
  'user.View assesement from employee and review manager. Panel result and comments will also be displayed here after you upload the data.':
    'View assessment from employee and review manager. Panel result and comments will also be displayed here after you upload the data.',
  'user.Assessment Result': 'Assessment Result',
  'user.HRBP': 'HRBP',
  'user.Submitted Successfully': 'Submitted Successfully',
  'user.your application has been submitted successfully!':
    'your application has been submitted successfully!',
  'user.Please wait for response and feedback from your review manager.':
    'Please wait for response and feedback from your review manager.',
  'user.View My Application': 'View My Application',
  'user.Back to Home': 'Back to Home',
  'user.My Team Applications': 'My Team Applications',
  'user.Application Approval Due Date': 'Application Approval Due Date',
  'user.Eligible Applicant': 'Eligible Applicant',
  'user.Applied Applicant': 'Applied Applicant',
  'user.Check the status of your team members’ applications. Review and evaluate the applications of your team members.':
    'Check the status of your team members’ applications. Review and evaluate the applications of your team members.',
  'user.The application is waiting for your approval.':
    'The application is waiting for your approval.',
  'user.The panel review application is not approved. Please have a career dialog with your team member.':
    'The panel review application is not approved. Please have a career dialog with your team member.',
  "user.Your team member's application is reopened. Please wait for your team member to reapply.":
    "Your team member's application is reopened. Please wait for your team member to reapply.",
  'user.Review and Evaluate': 'Review and Evaluate',
  'user.Download Assessment': 'Download Assessment',
  'user.Please click to choose which type of assessment you want. Once the file is ready, a download link will be sent to your Publicis mailbox':
    'Please click to choose which type of assessment you want. Once the file is ready, a download link will be sent to your Publicis mailbox',
  'user.Download latest assessment': 'Download latest assessment',
  'user.Download all assessment': 'Download all assessment',
  'user.View assessment and comments from your employee':
    'View assessment and comments from your employee',
  "user.Assess your employee's qualification of his/her current role":
    "Assess your employee's qualification of his/her current role",
  'user.Submit the assessment': 'Submit the assessment',
  'user.View My Team': 'View My Team',
  'user.√ and × are marked based on the valid record of training attendance. Talent who submitted the ROAR application has completed all the mandatory courses. You can also share your comments on the learning part.':
    '√ and × are marked based on the valid record of training attendance. Talent who submitted the ROAR application has completed all the mandatory courses. You can also share your comments on the learning part.',
  'user.Panel Comments': 'Panel Comments',
  'user.Assess your employee and leave comments':
    'Assess your employee and leave comments',
  'user.Message deleted': 'Message deleted',
  'user.Select your target role': 'Select your target role',
  'user.Review job qualification as reference for your future development':
    'Review job qualification as reference for your future development',
  'user.Submit the application': 'Submit the application',
  'user.Please select your target role to see job qualification list':
    'Please select your target role to see job qualification list',
  'user.Submit': 'Submit',
  'user.Submit Information': 'Submit Information',
  'user.Are you sure you want to submit this application now?':
    'Are you sure you want to submit this application now?',
  'user.Yes': 'Yes',
  'user.No': 'No',
  'user.Are you sure you want to leave the page? The information will be saved after you leave the page':
    'Are you sure you want to leave the page? The information will be saved after you leave the page',
  'user.Please select your target role to see learning resources.':
    'Please select your target role to see learning resources.',
  "user.You don't have application yet": "You don't have application yet",
  'user.You have successfully submitted your assessment':
    'You have successfully submitted your assessment',
  'user.You have disapproved this employee for panel review，Are you sure you want to proceed?':
    'You have disapproved this employee for panel review，Are you sure you want to proceed?',
  'user.You have approved this employee for panel review. Are you sure you want to proceed?':
    'You have approved this employee for panel review. Are you sure you want to proceed?',
  'user.Edit': 'Edit',
  'user.Selected': 'Selected',
  'user.items': 'items',
  'user.Your request has been received': 'Your request has been received',
  'user.Are you sure you want to reopen review manager’s assessment?':
    'Are you sure you want to reopen review manager’s assessment?',
  'user.Are you sure you want to reopen review manager’s assessment and employee’s application?':
    'Are you sure you want to reopen review manager’s assessment and employee’s application?',
  'user.Reopen Application': 'Reopen Application',
  'user.Back to The Previous Page': 'Back to The Previous Page',
  'user.No Data': 'No Data',
  'user.This Session is Offline': 'No online application process in this session.',
}
